import actionTypes from './constants';

/* */
export const initialize = (data) => (dispatch) => dispatch({
  type: actionTypes.enter.INITIALIZE,
  payload: data,
});

/* */
export const addEntrant = (entrant) => (dispatch) => dispatch({
  type: actionTypes.enter.ADD_ENTRANT,
  payload: entrant,
});

/* */
export const replaceEntrant = (entrant, index = null) => (dispatch) => dispatch({
  type: actionTypes.enter.REPLACE_ENTRANT,
  payload: entrant,
  index,
});

/* */
export const adjustEntrants = (number) => (dispatch) => dispatch({
  type: actionTypes.enter.ADJUST_ENTRANTS,
  payload: number,
});

/* */
export const setEvents = (data) => (dispatch) => dispatch({
  type: actionTypes.SET_EVENTS,
  payload: data,
});

/* */
export const setCalendar = (data) => (dispatch) => dispatch({
  type: actionTypes.SET_CALENDAR,
  payload: data,
});

/* */
export const updateEnter = (data) => (dispatch) => dispatch({
  type: actionTypes.enter.UPDATE_ENTER,
  payload: data,
});
